<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<p class="half">The Birth of the Soviet Secret Police</p>
<a id="page_iv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?62585a19